export default __webpack_public_path__ + "static/media/pdf.a9b90f3e.svg";